const originalFetch = window.fetch;
const GIFT_VARIANT = 52868144890221;

const RESETS_VARIANTS = {
  //The 5-Day Reset: Deluxe
  42429966778568: true,
  40517350064328: true,
  //The 5-Day Reset: Deluxe Vegan
  7473171529928: true,
  42429963960520: true,
  //The 5-Day Reset: Signature Edition Vegan
  7382988751048: true,
  42063577546952: true,
  //The 5-Day Reset: Signature Edition
  7294619844808: true,
  41742830829768: true,
  //The 5-Day Reset: Limited Edition
  6947094560968: true,
};
window.fetch = async function (input, init) {
  const response = await originalFetch(input, init);
  const inputUrl = typeof input === "string" ? input : input?.url;
  const method = init?.method || (typeof input !== "string" && input?.method);
  const methodUpper = method ? method.toUpperCase() : "";
  const isAdd = typeof inputUrl === "string" && inputUrl.includes("/cart/add.js");
  const isChange =
    (typeof inputUrl === "string" && inputUrl.includes("/cart/change.js")) ||
    (typeof inputUrl === "string" &&
      inputUrl.includes("/cart/update.js") &&
      methodUpper === "POST");
  const isClear =
    typeof inputUrl === "string" &&
    inputUrl.includes("/cart/clear.js") &&
    methodUpper === "POST";

  if (isAdd || isChange || isClear) {
    try {
      const cloned = response.clone();
      const data = await cloned.json();

      let action = "update";
      if (isAdd) action = "add";
      else if (isChange) {
        const body = init?.body;
        let parsedBody;
        try {
          parsedBody = typeof body === "string" ? JSON.parse(body) : body;
          if (parsedBody?.quantity === 0) action = "delete";
        } catch {}
      } else if (isClear) {
        action = "clear";
      }

      document.dispatchEvent(
        new CustomEvent("customCart:event", {
          detail: {
            action,
            cart: data,
          },
        })
      );
    } catch (err) {
      console.error("Error:", err);
    }
  }

  return response;
};

async function getCart() {
  try {
    const response = await fetch("/cart.js");
    const cart = await response.json();
    return cart;
  } catch (e) {
    console.error("Error fetching cart:", e);
    return null;
  }
}

document.addEventListener("customCart:event", (event) => {
  console.log("Product added:", event.detail.cart);
  let cart = event.detail.cart;
  const giftJustAdded = cart.items_added?.some(
    (item) => item.id === GIFT_VARIANT
  );
  getCart().then((cart) => {
    if (!cart) return;
    //if theres a reset in the cart, ensure theres one gift
    //if theres at least one reset and one gift returns true
    const gifts = checkGiftCount(cart.items);
    const resets = checkResetCount(cart.items);

    console.log(resets, gifts);
    if (resets > 0 && gifts < 1) {
      //add gift to cart
      if (!giftJustAdded) addGift();
    } else if (resets === 0 && gifts > 0) {
      //remove gift from cart
      handleDeleteGift(cart.items);
    }
  });
});

function checkGiftCount(items) {
  let totalGift = 0;

  items?.forEach((item) => {
    if (item.id === GIFT_VARIANT) {
      // Cambiar variant_id por id
      totalGift += item.quantity;
    }
  });

  return totalGift;
}

function checkResetCount(items) {
  let totalReset = 0;
  items?.forEach((item) => {
    if (RESETS_VARIANTS[item.id]) {
      // Cambiar variant_id por id
      totalReset += item.quantity;
    }
  });
  return totalReset;
}

function handleDeleteGift(items) {
  items.forEach((el) => {
    if (el.id == GIFT_VARIANT) {
      // Cambiar variant_id por id
      deleteGift(el.key, 0);
    }
  });
}
function addGift() {
  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: GIFT_VARIANT,
      quantity: 1,
      properties: {
        Delivery: "Gifts will ship separately the week of 1/12",
      },
    }),
  })
    .then((res) => res.json())
    .then((data) => {
      console.log("Gift added:", data);
    })
    .catch((err) => {
      console.error("Error adding gift:", err);
    });
}

function deleteGift(itemKey, newQty) {
  fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: itemKey,
      quantity: newQty,
    }),
  })
    .then((res) => res.json())
    .then((cart) => {
      console.log("Gift removed:", cart);

      // Refrescar el cart drawer
      refreshCartDrawer();
    })
    .catch((err) => {
      console.error("Error deleting gift:", err);
    });
}
